import 'buefy/dist/buefy.css'
import SmoothScrollbar from 'vue-smooth-scrollbar'
import Vue from 'vue'
import App from './app.vue'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.directive("focus", {
  inserted: function(el) {
    el.focus();
  },
});

import {
  Truncate,
  TruncateMiddle
} from "@/truncate.js";

Vue.use(SmoothScrollbar)
Vue.use(Buefy)
Vue.config.productionTip = false

Vue.filter("truncate", Truncate);
Vue.filter("truncateMiddle", TruncateMiddle);

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
